import { Link, useMatch } from "react-router-dom";
import { cn } from "@/lib/utils";
import { UnderlineLinkProps } from ".";


const UnderlineLink = ({
    to,
    children,
    spanProps,
    ...props
}: UnderlineLinkProps) => {
    const match = useMatch({ path: (to as string), end: true });
    return (
        <Link to={to} {...props}>
            <span {...spanProps} className={cn(" text-xs flex w-full gap-1 box-content", !!match && "underline-after", spanProps?.className)} >
                {children}
            </span>
        </Link>
    )
}

export { UnderlineLink }
